export function LegacyBursonRequestEventCtrl (
  $uibModalInstance,
  $scope,
  event,
  LegacyBursonEvents,
  messages
) {
  $scope.event = event;

  $scope.LegacyBursonEvents = new LegacyBursonEvents();

  $scope.continue = function () {
    $scope.LegacyBursonEvents.getBursonItems($scope.event)
    .then(data => {
      $uibModalInstance.close(data);
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.overwrite = function () {
    $scope.LegacyBursonEvents.overwrite($scope.event)
    .then(data => {
      $uibModalInstance.close(data);
    })
    .catch(err => {
      $uibModalInstance.dismiss();
    });
  };
}